import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class TaskFormBaseComponent {
  taskForm: FormGroup;
  errorMessage: string | null = null;

  constructor(protected fb: FormBuilder) {
    this.taskForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  markAllFieldsAsTouched(): void {
    Object.keys(this.taskForm.controls).forEach(field => {
      const control = this.taskForm.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  get name() {
    return this.taskForm.get('name');
  }
  get description() {
    return this.taskForm.get('description');
  }
}
